import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import BusinessPost from '../../components/BusinessPost';
import OfficerPost from '../../components/OfficerPost';
import { UserContext } from '../../context/User';

const PostPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      <LoginHeader />
      <main>
        {role === "business" && <BusinessPost />}
        {role === "officer" && <OfficerPost />}
      </main>
      <LoginFooter />
    </>
  )
}

export default PostPage;